import { Asset, Scene, SceneAssetItem } from '@monorepo/types';
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import SceneImage from '../../../scene-image/scene-image';
import { useVideoContext } from '../../../../../../hooks/use-video';
import SceneItemDuration from '../../scene-item-duration';
import { Flex } from 'antd';
import SceneItemWrapper from '../scene-item-wrapper';

interface Props {
  data: SceneAssetItem;
  scene: Scene;
  index: number;
}

const SceneAsset: FunctionComponent<Props> = ({
  data,
  scene,
  index: assetIndex,
}) => {
  const [asset, setAsset] = useState<Asset>();
  const {
    setSceneId,
    assets: scenesAssets,
    fetchAsset,
    modalRef,
  } = useVideoContext();

  useEffect(() => {
    const init = async () => {
      if (scene && data.assetId) {
        let asset = scenesAssets.find((asset) => asset._id === data.assetId);

        if (!asset) {
          asset = await fetchAsset(data.assetId);
        }

        setAsset(asset);
      }
    };

    init();
  }, [data?.assetId]);

  const item = scene.items[assetIndex];

  const openModal = () => {
    modalRef.current?.open({
      asset: asset ? asset : null,
      assetIndex,
    });

    setSceneId(scene._id);
  };

  return (
    <SceneItemWrapper
      sceneId={scene._id}
      sceneItemIndex={assetIndex}
      openModal={openModal}
    >
      <Flex justify={'start'} gap={30} align={'center'} className="scene-asset">
        <SceneImage scene={scene} asset={asset} onAssetClick={openModal} />
        <SceneItemDuration sceneItem={item} scene={scene} />
      </Flex>
    </SceneItemWrapper>
  );
};

export default SceneAsset;
